import { HttpClient } from '@angular/common/http';
import { Component, Inject } from '@angular/core';
import { SalesDocument } from '@icc/b2b/shared';
import { logger } from '@icc/shared/helpers/b2b';
import { DIALOG_DATA, DialogRef } from '@icc/ui';
import { TranslateService } from '@ngx-translate/core';
import { lastValueFrom } from 'rxjs';

@Component({
    selector: 'icc-cancel-order-dialog',
    templateUrl: './cancel-order-dialog.component.html',
    styleUrls: ['./cancel-order-dialog.component.scss'],
})
export class CancelOrderDialogComponent {
    inProgress = false;

    message = '';
    messages: string[] = [];
    messageState: 'default' | 'error' = 'default';

    constructor(
        @Inject(DIALOG_DATA)
        public data: {
            document: SalesDocument;
            buyDocuments: SalesDocument[];
            body: string
        },
        private translateService: TranslateService,
        private dialogRef: DialogRef,
        private http: HttpClient,
    ) {}

    async cancel() {
        this.inProgress = true;
        const document = this.data.buyDocuments.length > 0 ? this.data.buyDocuments[0] : this.data.document;
        this.message = this.translateService.instant(
            'SALES_DOCUMENT|Trwa anulowanie zamówienia w systemie zewnętrznym.',
        );
        this.messages = [];
        this.messageState = 'default';
        try {
            const result = await lastValueFrom(this.http.post<{status: 'ok' | 'error';}>('/api/b2b/order-external/cancel', {
                documentId: document.uuid,
                documentExternalId: document.externalId,
            }));
            if (result.status === 'ok') {
                this.inProgress = false;
                this.message = '';
                this.messages = [];
                this.dialogRef.close({
                    status: 'ok',
                });
            }
        } catch (e) {
            logger.error(e);
            if (e.error?.messages?.length) {
                this.message = '';
                this.messages = e.error.messages;
            } else {
                this.message = this.translateService.instant(
                    'SALES_DOCUMENT|Anulowanie w systemie zewnętrznym nie powiodło się. Spróbuj ponownie później.');
                this.messages = [];
            }
            this.messageState = 'error';
            this.inProgress = false;
        }
    }

    close() {
        this.dialogRef.close();
    }
}
